import { useEffect } from "react";

/* Sticky US / Europe / Global jump-tabs with hash bookmarks (#us #europe #global). */
const TABS = [
  { key: "us", label: "US" },
  { key: "europe", label: "Europe" },
  { key: "global", label: "Global" },
];

export default function PopSectionTabs({ prefix }) {
  const jump = (key) => {
    const el = document.getElementById(key);
    if (el) {
      window.history.replaceState(null, "", `#${key}`);
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (TABS.some((t) => t.key === hash)) {
      setTimeout(() => document.getElementById(hash)?.scrollIntoView({ block: "start" }), 400);
    }
  }, []);

  return (
    <div className="sticky top-16 z-30 bg-white/95 backdrop-blur border-b border-zinc-200 -mx-5 lg:-mx-8 px-5 lg:px-8 py-2 mb-6 flex gap-2"
      data-testid={`${prefix}-section-tabs`}>
      {TABS.map((t) => (
        <button key={t.key} onClick={() => jump(t.key)} data-testid={`${prefix}-tab-${t.key}`}
          className="px-5 py-2.5 text-base font-700 border border-zinc-300 bg-white text-zinc-700 hover:bg-primary hover:text-white hover:border-primary transition-colors">
          {t.label}
        </button>
      ))}
    </div>
  );
}
